import { useState } from "react";
import { Sparkles } from "lucide-react";

const items = [
  {
    id: "siding",
    label: "House Siding",
    before:
      "https://customer-assets.emergentagent.com/job_pressurewash-pro-3/artifacts/202v0x2z_IMG_20260604_103115.jpg",
    after:
      "https://customer-assets.emergentagent.com/job_pressurewash-pro-3/artifacts/abcytufy_IMG_20260604_103114.jpg",
  },
  {
    id: "fleet",
    label: "Heavy Truck",
    before:
      "https://customer-assets.emergentagent.com/job_pressurewash-pro-3/artifacts/f65xet57_IMG_20260604_103102.jpg",
    after:
      "https://customer-assets.emergentagent.com/job_pressurewash-pro-3/artifacts/u5e59g9g_IMG_20260604_103101.jpg",
  },
];

export default function BeforeAfter() {
  const [active, setActive] = useState(items[0].id);
  const current = items.find((i) => i.id === active);

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="px-6 md:px-12 lg:px-20 py-24 md:py-32 border-b border-[#2A2A2A]"
    >
      <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
        <div className="lg:col-span-7">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#FFD600]">
            03 — Receipts
          </span>
          <h2 className="font-display font-bold uppercase tracking-tight leading-[0.9] text-4xl sm:text-5xl lg:text-6xl mt-4">
            Before. After.
            <br />
            <span className="text-[#FFD600]">No filter.</span>
          </h2>
        </div>
        <div className="lg:col-span-5 flex flex-wrap gap-2">
          {items.map((it) => (
            <button
              key={it.id}
              data-testid={`gallery-tab-${it.id}`}
              onClick={() => setActive(it.id)}
              className={`px-5 py-3 text-xs font-bold uppercase tracking-wider border transition-colors ${
                active === it.id
                  ? "bg-[#FFD600] text-black border-[#FFD600]"
                  : "border-[#2A2A2A] text-gray-300 hover:border-[#FFD600] hover:text-[#FFD600]"
              }`}
            >
              {it.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-px bg-[#2A2A2A] border border-[#2A2A2A]">
        <div className="relative bg-[#0A0A0A] aspect-[4/3] overflow-hidden">
          <img
            src={current.before}
            alt={`${current.label} before`}
            className="w-full h-full object-cover"
          />
          <span className="absolute top-5 left-5 bg-black/80 text-white text-[10px] font-bold uppercase tracking-[0.3em] px-3 py-2 border border-white/20">
            Before
          </span>
        </div>
        <div className="relative bg-[#0A0A0A] aspect-[4/3] overflow-hidden">
          <img
            src={current.after}
            alt={`${current.label} after`}
            className="w-full h-full object-cover"
          />
          <span className="absolute top-5 left-5 bg-[#FFD600] text-black text-[10px] font-bold uppercase tracking-[0.3em] px-3 py-2 inline-flex items-center gap-2">
            <Sparkles size={12} /> After
          </span>
        </div>
      </div>
    </section>
  );
}
